import { INDEX_MINT, INDEX_SYMBOL, JUPITER_SWAP, STONKFUN_TOKEN } from "../lib/data";

export default function SwapPage() {
  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell readable">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> Swap
        </p>
        <h2 className="section-title">{`Buy $${INDEX_SYMBOL}`}</h2>
        <p className="section-lead left">
          Trade on StonkFun (native pool) or Jupiter. Creator fees from every
          trade fund the rotating basket.
        </p>

        <div className="swap-grid">
          <a
            className="swap-card swap-card--primary"
            href={STONKFUN_TOKEN}
            target="_blank"
            rel="noreferrer"
          >
            <span className="swap-card__eyebrow">Recommended</span>
            <h3>StonkFun</h3>
            <p>
              {`Native launch pool — standard 2% fee tier. Best place to buy and sell $${INDEX_SYMBOL}.`}
            </p>
            <span className="btn btn-lime">Open StonkFun →</span>
          </a>

          <a
            className="swap-card"
            href={JUPITER_SWAP}
            target="_blank"
            rel="noreferrer"
          >
            <span className="swap-card__eyebrow">Aggregator</span>
            <h3>Jupiter</h3>
            <p>{`Route SOL → $${INDEX_SYMBOL} across Solana DEX liquidity.`}</p>
            <span className="btn btn-ghost">Open Jupiter →</span>
          </a>
        </div>

        <div className="panel" style={{ marginTop: "1.25rem" }}>
          <h3>Contract</h3>
          <p className="mono" style={{ wordBreak: "break-all" }}>
            {INDEX_MINT || "Contract address drops at launch"}
          </p>
          <p style={{ marginBottom: 0 }}>
            Confirm the mint before swapping. Fee model: standard · 2%.
          </p>
        </div>
      </div>
    </section>
  );
}
